

<template>
  <div
    class="ct"
    :style="{width: width}">
    <div><img
      class="imgs"
      :style="{height: height, width: width, borderRadius: isRounded && '50%'}"

      :src="imgSrc"
      :alt="alt"></div>
    <div><strong>{{ name }}</strong></div>
    <div>{{ title }}</div>
    <div class="asc" v-if="infos.length > 0"><a
      class="as"
      target="_blank"
      v-for="(info, i) in infos"
      :key="i"
      :href="info.link">{{ info.name }}</a></div>
  </div>
</template>

<script>
export default {
  name: "Persona",
  props: {
    imgSrc: String,
    alt: String,
    height: { type: String, default: "200px" },
    width: { type: String, default: "150px" },
    isRounded: Boolean,
    name: String,
    title: String,
    cvLink: String,
    linkedinLink: String,
    twitterLink: String,
    mailLink: String,
    publicationsLink: String,
    webSite: String
  },
  computed: {
    infos() {
      return [
        { name: "CV", link: this.cvLink },
        { name: "Linkedin", link: this.linkedinLink },
        { name: "Twitter", link: this.twitterLink },
        { name: "Mail", link: this.mailLink && `mailto:${this.mailLink}` },
        { name: "Publications", link: this.publicationsLink },
        { name: "Site web", link: this.webSite }
      ].filter(d => !!d.link);
    }
  }
};
</script>

<style scoped>
.ct {
  text-align: center;
  margin: 1em;
}
.imgs {
  width: 150px;
  object-fit: cover;
}

.as {
  margin-right: 0.5em;
}

.asc {
  flex-wrap: wrap;
  justify-content: center;
  display: flex;
}
</style>
